import { render, staticRenderFns } from "./AppModals.vue?vue&type=template&id=8732406e"
import script from "./AppModals.vue?vue&type=script&lang=js"
export * from "./AppModals.vue?vue&type=script&lang=js"
import style0 from "./AppModals.vue?vue&type=style&index=0&id=8732406e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports